import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { COURSE_HREF, MARKETING_CTAS } from '@/lib/marketingCtas';
import { useAuth } from '@/contexts/AuthContext';
import { AppNotFoundPage } from '@/pages/AppNotFoundPage';

const LINKS = [
  { to: COURSE_HREF, label: 'The free SAT course' },
  { to: '/how-it-works/students/', label: 'How tutoring works' },
  { to: '/faq/', label: 'FAQ' },
  { to: '/login', label: 'Log in' },
] as const;

/** Rendered inside MarketingLayout (see Router), so the site header and footer frame it. */
export function NotFoundPage() {
  const { isAuthenticated } = useAuth();
  if (isAuthenticated) return <AppNotFoundPage />;

  return (
    <>
      <title>Page not found | Mentara</title>
      <meta name="robots" content="noindex" />

      <div className="mx-auto flex min-h-[55vh] w-full max-w-xl flex-col items-center justify-center gap-5 px-4 py-16 text-center">
        <p className="text-6xl font-bold tracking-tight text-primary">404</p>
        <h1 className="text-2xl font-semibold tracking-tight">Page not found</h1>
        <p className="text-muted-foreground">The page you are looking for does not exist or has moved.</p>
        <Button asChild size="lg">
          <Link to={COURSE_HREF}>{MARKETING_CTAS.closeCourse.label}</Link>
        </Button>
        <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm">
          <li>
            <Link to="/" className="underline underline-offset-4 hover:text-primary">Back to home</Link>
          </li>
          {LINKS.map(({ to, label }) => (
            <li key={to}>
              <Link to={to} className="underline underline-offset-4 hover:text-primary">{label}</Link>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}
